// extracted by mini-css-extract-plugin
export default {"customer-name-lookup-page-container":"CustomerNameLookupPage_customer-name-lookup-page-container__AI19C"};